<template>
<nav>
    <div class="container">
        
        <div id="navbar_mobile" class="row mx_0_5">
            <div class="col_auto py_0_5 items_center">
                <router-link to="/" class="nav_link">
                    <img class="club_logo" src="/images/navbar_logo.png">
                </router-link>
            </div>
            <div class="col_auto py_0_5 mx_auto items_center">
                <router-link to="/" class="nav_link">
                    <span class="club_name">TAEGUK Essen e.V.</span>
                </router-link>
            </div>
            <div class="col_auto py_0_5 items_center">
                <button id="navbar_toggler" @click="toggleNavbar">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-list" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"/>
                    </svg>
                </button>
            </div>
        </div>
        <div id="navbar" class="row mx_0_5">
            <div class="col pb_0_5 pt_md_0_5">
                <hr>
                <ul>
                    <li>
                        <router-link to="/" active-class="active" class="nav_link">Startseite</router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'training' }" active-class="active" class="nav_link">Training</router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'kontakt' }" active-class="active" class="nav_link">Kontakt & Anfahrt</router-link>
                    </li>
                    <li>
                        <router-link :to="{ name: 'training-home' }" active-class="active" class="nav_link">Training zu Hause</router-link>
                        <!--
                        Online-Training
                        Trainingshilfe
                        Materialien
                        Grundlagen
                        Kompendium
                        -->
                    </li>
                    <li class="ml_auto px_1 py_0_5 items_center">
                        <button id="toggle_btn" class="toggle_btn" @click="toggleThemeSwitch"></button>
                        <label for="toggle_btn" class="ml_0_5 items_center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-moon-fill" viewBox="0 0 16 16">
                                <path d="M6 .278a.77.77 0 0 1 .08.858 7.2 7.2 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277q.792-.001 1.533-.16a.79.79 0 0 1 .81.316.73.73 0 0 1-.031.893A8.35 8.35 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.75.75 0 0 1 6 .278"/>
                            </svg>
                        </label>
                    </li>
                </ul>
                <hr>
            </div>
        </div>

    </div>
</nav>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'Navi',

    props: {
        isDarkMode: {
            type: Boolean,
            required: true
        }
    },

    mounted() {
        this.$router.beforeEach((to, from, next) => {
            const navbarElem = document.getElementById('navbar');
            if (navbarElem) {
                navbarElem.classList.remove('show');
            }
            next();
        });
    },
    
    methods: {
        toggleNavbar() {
            const navbarElem = document.getElementById('navbar');
            if(navbarElem){
                navbarElem.classList.toggle('show');
            }
        },

        toggleThemeSwitch() {
            const toggleBtn = document.getElementById('toggle_btn');
            if(toggleBtn){
                toggleBtn.classList.toggle('on');
            }
            const isDarkModeEnabled = !this.isDarkMode;
            this.$emit('change-theme', isDarkModeEnabled);
        }
    }
});
</script>
